import styled from 'styled-components/macro';

import Typography from 'components/Typography/Typography';

export const FiltersWrapStyled = styled.div`
  justify-content: flex-start;
  margin: 1.5rem 0 1rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin: 2.125rem 0 1.625rem;
    }
  `}
`;

export const CardViewStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem 1.875rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      grid-template-columns: 1fr 1fr;
    }

    ${theme.devices.largeDesktop} {
      grid-template-columns: 1fr 1fr 1fr;
    }
  `}
`;

export const CardStyled = styled.div`
  padding: 0.875rem 1.375rem 0.875rem 0.875rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radius.md};
  cursor: pointer;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding: 1.25rem;
    }
  `}
`;

export const TextTitleStyled = styled(Typography)`
  color: ${({ theme }) => theme.colors.primary.variant7};
  padding-bottom: 0.25rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      padding-bottom: 0;
    }
  `}
`;

export const TextRoNumberStyled = styled(Typography)`
  font-size: ${({ theme }) => theme.fontSize['2xl']};

  ${({ theme }) => `
    ${theme.devices.tablet} {
      font-size: ${theme.fontSize['4xl']};
    }
  `}
`;

export const FlexRowStyled = styled.div`
  display: flex;
  align-items: center;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin-top: 1.375rem;
    }
  `}
`;

export const FlexRowItemStyled = styled.div`
  &:not(:last-child) {
    margin-right: 2.5rem;
  }

  ${({ theme }) => `
    ${theme.devices.tablet} {
      &:not(:last-child) {
        margin-right: 1.5rem;
      }
    }
  `}
`;

export const TextDetailsStyled = styled(Typography)`
  font-size: ${({ theme }) => theme.fontSize['2xl']};
`;
